import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/[locale]/inquiry/page.client.tsx");
